import React from 'react';
import { ItemTable } from '../components/ItemComponents/ItemTable';
import { FilterTag } from '../components/ItemComponents/FilterTag';
import { useSearchParams } from 'react-router-dom';
import { Stack } from 'react-bootstrap';

export function ListItemsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const warehouseId = searchParams.get('warehouseId') || undefined;

  const removeWarehouseFilter = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('warehouseId');
    setSearchParams(newParams);
  };

  return (
    <Stack gap={3}>
      {warehouseId && (
        <Stack direction="horizontal" gap={2}>
          <FilterTag warehouseId={warehouseId} onRemove={removeWarehouseFilter} />
        </Stack>
      )}
      <ItemTable warehouseId={warehouseId} />
    </Stack>
  );
}
      
